import { useEffect, useState } from 'react';
import { getPacificNow, convertToPacificDate } from 'components/Page/Webinar/utils/postsUtils';

const useCountdown = (targetDate) => {
  const [time, setTime] = useState({
    days: 0,
    hours: 0,
    min: 0,
    sec: 0,
  });

  const calculateCountdown = (endDate) => {
    const now = getPacificNow();
    const target = convertToPacificDate(endDate);
    const diff = target.diff(now, 'second');

    if (diff <= 0) return false;

    const days = Math.floor(diff / 86400);
    const hours = Math.floor((diff % 86400) / 3600);
    const min = Math.floor((diff % 3600) / 60);
    const sec = diff % 60;

    return { days, hours, min, sec };
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const updatedTime = calculateCountdown(targetDate);
      if (updatedTime) {
        setTime(updatedTime);
      } else {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return time;
};

export default useCountdown;
